import React from 'react'
import type { Img } from '@/services/images'

interface AttributionProps {
  image: Img | undefined
  className?: string
}

// Subtle photographer credit rendered under/on image galleries per Unsplash TOS.
export function Attribution({ image, className = '' }: AttributionProps) {
  if (!image?.photographer) return null
  return (
    <a
      href={image.photographerUrl || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-[10px] font-semibold text-white/70 hover:text-white/100 transition-colors ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      📷 {image.photographer}
    </a>
  )
}
